import React from 'react';
import MemoryIcon from '@mui/icons-material/Memory';
import FirmwareFile from './FirmwareFile';
import OverviewPanel from './OverviewPanel';

const FIRMWARE_HINT = 'latest - старшая версия в боевом канале, её приложение предлагает пользователям. Если OTA-сервер недоступен, данных нет.';

const FirmwareFilesPanel = ({ firmware }) => {
  if (firmware === undefined) return null;

  const releases = firmware?.releases ?? [];
  const latest = firmware?.latest;

  return (
    <OverviewPanel title="Файлы прошивки fw_METN" hint={FIRMWARE_HINT} icon={<MemoryIcon className="text-gray-500" />}>
      {firmware == null ? (
        <p className="text-sm text-gray-500 mt-3">OTA-сервер недоступен.</p>
      ) : (
        <>
          <div className="mt-4 rounded-2xl border border-green-200 bg-green-50 px-4 py-3">
            <div className="text-xs uppercase text-green-700 mb-1">Предлагается пользователям</div>
            {latest ? <FirmwareFile file={latest} /> : <p className="text-sm text-gray-600">В боевом канале нет версии</p>}
          </div>

          {releases.length ? (
            <div className="mt-4">
              <div className="text-xs uppercase text-gray-400">В каналах</div>
              <div className="divide-y divide-gray-100">
                {releases.map((file, index) => (
                  <FirmwareFile key={`${file?.channel}-${file?.file_name}-${index}`} file={file} />
                ))}
              </div>
            </div>
          ) : (
            <p className="text-sm text-gray-500 mt-3">В каналах нет файлов прошивки</p>
          )}
        </>
      )}
    </OverviewPanel>
  );
};

export default FirmwareFilesPanel;
